// ScrollToTopButton.tsx
import React, { useState, useEffect } from 'react';

interface ScrollToTopButtonProps {
  backgroundColor?: string;
  color?: string;
  bottom?: string;
  right?: string;
  scrollThreshold?: number;
  size?: number;
  iconSize?: number;
  borderRadius?: string;
  boxShadow?: string;
}

const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({
  backgroundColor = '#3A9188',
  color = 'white',
  bottom = '90px',
  right = '20px',
  scrollThreshold = 300,
  size = 60,
  iconSize = 36,
  borderRadius = '50%',
  boxShadow = '0 2px 10px rgba(0,0,0,0.2)'
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  
  useEffect(() => {
    const toggleVisibility = (): void => {
      if (window.pageYOffset > scrollThreshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, [scrollThreshold]);
  
  const scrollToTop = (): void => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <>
      {isVisible && (
        <button 
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom,
            right,
            zIndex: 9999,
            borderRadius,
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor,
            color,
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow,
            fontSize: `${iconSize}px`,
            outline: 'none',
            transition: 'all 0.3s ease'
          }}
          aria-label="Scroll to top"
        >
          ↑
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;
